module.exports = __webpack_public_path__ + "img/Renfrewshire.f20a10c1.png";